<div class="ui-g-12 ui-md-6">
  <!-- Button visualizza Prenotazioni Filtrate per Negozio Utente -->
  <button
    pButton
    class="k-generic-btn"
    type="button"
    (click)="getReservations(false)"
    label="{{ 'reservations.filteredByUserStore' | translate }}"
    [disabled]="!showAllReservations">
  </button>
  <!-- Button visualizza Tutte le Prenotazioni -->
  <button
    pButton
    class="k-generic-btn"
    type="button"
    (click)="getReservations(true)"
    label="{{ 'common.all' | translate }}"
    [disabled]="showAllReservations">
  </button>
</div>
<div class="ui-g-12 ui-md-6"></div>
<div class="ui-g-12">
  <app-kontable
    #table
    title="{{ 'reservations.reservationSearch' | translate }}"
    [columns]="[
      {field: 'id', title: 'reservations.reservationNumber'},
      {field: 'card_no', title: 'card.card_no', maxFilterChars: maxChars},
      {field: 'customerDescription', title: 'common.customers'},
      {field: 'vat_fiscal_code', title: 'customerList.fiscalVat'},
      {field: 'store', title: 'reservations.reservationStore'},
      {field: 'dt_reservation', title: 'reservations.reservationDate', type: 'date', filterType: dateFilter},
      {field: 'gift_code', title: 'reservations.giftCode'},
      {field: 'gift_description', title: 'reservations.giftDescription'},
      {field: 'store_pickup', title: 'reservations.deliveryStore'},
      {field: 'gift_type', title: 'catalog.giftType', filterType: selectFilter, filterOptions: {values: giftType}},
      {field: 'delivery_type', title: 'catalog.deliveryType', filterType: selectFilter, filterOptions: {values: deliveryType}},
      {field: 'status', title: 'common.status', filterType: selectFilter, filterOptions: {values: status}},
      {field: 'catalog_description', title: 'catalog.activeCatalog', filterType: selectFilter, filterOptions: {values: activeCatalog}}
    ]"
    [service]="service"
    [paginationType]="paginationType"
    [showRecoverButton]="false"
    [showInfoButton]="false"
    [showAddButton]="false"
    [showDeleteButton]="false"
    [showDetailsButton]="false"
    [showEditButton]="false"
    [showReport]="true"
    [additionalRowCommands]="customRow"
    [showExtSearch]="true"
    [extSearchConfigKey]="'extsearch-reservation-search'"
    [extSearchResult]="extSearchResult"
    (extSearchReq)="sendExtSearchQuery($event, showAllReservations)"
    [totalRecords]="totalRecords"
    [showDownloadExcelBtn]="true"
    [fixedFilters]="initialFilters"
    (onDownloadExcel)="downloadExcel($event, showAllReservations)"
  >

    <!-- Bottoni custom -->
    <ng-template #customRow data-testid="customRow" let-row>
      <!-- Dialog di dettaglio relativa -->
      <p-button pTooltip="{{ 'common.view' | translate }}" icon="fa fas fa-eye" styleClass="ui-button-info" (onClick)="showDetail(row)"></p-button>
      <!-- Link alle prenotazioni del cliente -->
      <p-button *ngIf="row.operability === '1'" pTooltip="{{ 'reservations.customerReservations' | translate }}" icon="fa fas fa-search" styleClass="ui-button-info" (onClick)="goToCustomerReservations(row)"></p-button>
    </ng-template>

  </app-kontable>

  <p-dialog
    class="reservation-details-dialog"
    *ngIf="dialog"
    [(visible)]="dialog"
    [modal]="true"
    header="{{modalTitle + ' ' + tempId}}"
    [minWidth]="500"
    [draggable]="false"
    [resizable]="false"
    (onHide)="closeDialog()">
    <app-loyalty-reservation-details [record]="record"></app-loyalty-reservation-details>
  </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reservation-search/loyalty-reservation-search.component.html